import React from "react";
import { Button, Col } from "react-bootstrap";
import ReactLoading from "react-loading";

import "./Buttons.css";

function BtnEdit({ size, onClick, isClicked, label, disabled }) {
  return (
    <div className="p-1">
      {isClicked ? (
        <Button className="action-btn update loader" size={size} disabled>
          <ReactLoading type={"balls"} height={20} width={25} color="#fff" />
        </Button>
      ) : (
        <Button
          className="action-btn update"
          size={size}
          onClick={onClick}
          disabled={disabled}
        >
          {label}
        </Button>
      )}
    </div>
  );
}

export default BtnEdit;
